export default "__VITE_ASSET__CuPezF6b__"